export const VisionMode = {
  CLASSIQUE: 'CLASSIQUE',
  AMELIORE: 'AMELIORE',
}

export const ColorTheme = {
  CLASSIQUE: 'CLASSIQUE',
  DARK: 'DARK',
}
